import {
  Button,
  ButtonSize,
  ButtonStyle,
  colors,
  Hyperlink,
  Loading,
} from '@one-tree/library'
import React, { ReactElement } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { useOrganisation } from '../../../context/OrganisationProvider'
import { RoutePath } from '../../../types/Routes'
import {
  getDateAndTime,
  getPromoDiscount,
  getVoucherValidity,
  Promotions,
  StatusText,
} from './PromotionHelper'

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  border: 1px solid ${colors.gray};
  th,
  td {
    padding: 8px;
  }
  th {
    padding-top: 9px;
    border-bottom: 1px solid ${colors.gray};
    background-color: ${colors.lightGray};
  }
  td:last-child {
    text-align: right;
  }
`
const Error = styled.div`
  padding: 50px;
  background-color: ${colors.lightGray};
  text-align: center;
`

type Props = {
  promotions: Promotions
  loading: boolean
}
export default function PromotionTable(props: Props): ReactElement {
  const { promotions, loading } = props
  const { organisation } = useOrganisation()
  const history = useHistory()

  if (loading) return <Loading fullPage={true} />
  if (!loading && !promotions.length) {
    return (
      <Error>
        <div>No promotions found.</div>
        <Hyperlink href={RoutePath.CreatePromotion}>
          Create a new promotion.
        </Hyperlink>
      </Error>
    )
  }

  const handleEdit = (id: number): void => {
    history.push(`${RoutePath.ManagePromotions}/${id}`)
  }

  return (
    <Table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Discount</th>
          <th>Code</th>
          <th>Active from</th>
          <th>Deactivates on</th>
          <th>Active</th>
          <th>Voucher validity</th>
          <th>Sales</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {promotions.map((promo) => (
          <tr key={promo.id}>
            <td>{promo.name}</td>
            <td>{getPromoDiscount(promo, organisation?.currencyCode)}</td>
            <td>{promo.code || '-'}</td>
            <td>{getDateAndTime(promo.activeFrom)}</td>
            <td>{getDateAndTime(promo.deactivateOn)}</td>
            <td>
              <StatusText promo={promo} />
            </td>
            <td>{getVoucherValidity(promo)}</td>
            <td>{promo.sales || 0}</td>
            <td>
              <Button
                buttonStyle={ButtonStyle.Secondary}
                buttonSize={ButtonSize.Mini}
                onClick={(): void => handleEdit(promo.id)}
              >
                Edit
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
